const ROOT = 'configure.feesAndIncentives';

export default {
  RETURN_PROCESSING_FEES: `${ROOT}.returnProcessingFees`,
  UNIT_RESTOCKING_FEES: `${ROOT}.unitRestockingFees`,
  REFUND_METHOD_PROCESSING_FEES: `${ROOT}.refundMethodProcessingFees`,
  SHIPPING_FEES: `${ROOT}.shippingFees`,
  INCENTIVE_AMOUNTS: `${ROOT}.incentiveAmounts`
};
